import { keyframes } from '../theming-sc/'

/**
 * text-overflow: ellipsis;
 */
const textOverflowEllipsis = `
  text-overflow: ellipsis; 
  overflow: hidden;
  white-space: nowrap; 
`

/**
 * Switching visibility between two elements in the same place
 */
const switchVisibility = ({ visible, timeScale = 1 }) => {
  const time = visible ? 0.4 * timeScale : 0.2 * timeScale
  const delay = visible ? 0.2 * timeScale : 0

  return {
    visibility: visible ? 'visible' : 'hidden',
    opacity: visible ? 1 : 0,
    transition: `opacity ${time}s ease-in-out, visibility ${time}s`,
    transitionDelay: `${delay}s`
  }
}

const keyframesFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

/**
 * Map of properties to be prefixed.
 * @TODO Needs more entries, just barebones for now
 */
const prefixesMap = {
  transform: ['WebkitTransform'], // ,'msTransform' -> Only needed for IE < 11
  animation: ['WebkitAnimation'],
  animationDuration: ['WebkitAnimationDuration'],
  animationDelay: ['WebkitAnimationDelay']
}

/**
 * Fills in prefixed CSS properties.
 * Useful for example with styled-components when using .attr({ style }).
 *
 * Example:
 *
 *   const styles = prefixed({
 *      transform: 'translate(10px,10px)'
 *   })
 *   // styles = { transform: 'translate(1px,1px)', WebkitTransform: 'translate(1px,1px)' }
 *
 *
 * @param {Object} styles
 */
const prefixed = (styles) => {
  // styles = { ...styles } // Don't mutate, desirable?
  Object.keys(styles).forEach(cssName => {
    if (prefixesMap[cssName]) {
      prefixesMap[cssName].forEach(prefixed => {
        if (!styles[prefixed]) {
          styles[prefixed] = styles[cssName]
        }
      })
    }
  })
  return styles
}

/**
 * Sets prefixed styles in element.style.
 * Inline style isn't the first choice, but but sometimes useful.
 *
 * Example:
 *
 *    setStylesPrefixed( myDiv, { transform: 'translate(1px,1px)' } )
 *
 *    // Now element has this
 *    // <div style="transform: translate(1px,1px); WebkitTransform: translate(1px,1px);">
 *
 *
 * @param {Element} element
 * @param {Object} styles
 */
const setStylePrefixed = (element, styles) => {
  if (element && styles) {
    Object.keys(prefixed(styles)).forEach(cssName => {
      element.style[cssName] = styles[cssName]
    })
  }
}

export {
  textOverflowEllipsis,
  switchVisibility,
  keyframesFadeIn,
  prefixed,
  setStylePrefixed
}
